import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../common/contexts/UserContext";
import { Role } from "../common/types/roles";
import { PrivateRouteProps } from "../types/privateRouteProps.interface";

const PrivateRoute: React.FC<PrivateRouteProps> = ({
    component: Component,
    componentName,
    redirectComponent: Rc,
    redirectPath = "/",
}) => {
    const { user } = useUser();

    if (typeof Rc === "function") Rc = <Rc />;

    if (user === undefined) return <></>;

    if (user === null) return <Navigate to={redirectPath} />;

    const isAuthorized = user?.role && roleRoutePermissions[user.role]?.includes(componentName);

    return isAuthorized
        ? (typeof Component === "function" ? <Component /> : Component)
        : (Rc ?? <Navigate to={redirectPath} />);
};

export default PrivateRoute;

const roleRoutePermissions: { [role in Role]: string[] } = {
  Admin: [
    "Patients",
    "Fota",
    "About",
    "Support",
    "Contact",
    "Settings",
    "Sites",
    "Dashboard",
    "Users",
    "Devices",
    "CreateUser",
    "CreateSite",
    "EditUser",
    "EditPatient",
    "EditSite",
    "EditProfile",
    "Documentation",
    "DeviceProfile",
    "PatientProfile",
  ],
  HCP: [
    "Patients",
    "About",
    "Support",
    "Contact",
    "Settings",
    "Dashboard",
    "EditPatient",
    "EditProfile",
    "Documentation",
  ],
};
